__turbopack_context__.v({
  "authorDetails": "r6Xy8G_authorDetails",
  "authorSection": "r6Xy8G_authorSection",
  "bio-image": "r6Xy8G_bio-image",
  "section": "r6Xy8G_section",
  "sectionNoMargin": "r6Xy8G_sectionNoMargin",
});
